import { useReducer } from 'react';

const useFormBuilder = (formData) => {
  const initialState = {
    data: { ...formData },
    errors: {},
  };

  function reducer(state, action) {
    switch (action.type) {
      case 'updateFormDataObj':
        return {
          ...state,
          data: { ...state.data, ...action.payload },
        };
      case 'updateFormDataErrors':
        return {
          ...state,
          errors: { ...state.errors, [action.payload.id]: action.payload.value },
        };
      case 'resetForm':
        return {
          ...initialState,
        };
      default:
        return { ...state };
    }
  }

  const updateFormData = (payload) => {
    dispatch({
      type: 'updateFormDataObj',
      payload,
    });
  };

  const updateErrorData = ({ id, value }) => {
    dispatch({
      type: 'updateFormDataErrors',
      payload: { id, value },
    });
  };

  const resetFormData = () => {
    dispatch({ type: 'resetForm' });
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  return {
    formData: state,
    updateFormData,
    updateErrorData,
    resetFormData,
  };
};

export default useFormBuilder;
